
import TicketDiscount from "../../../assets/filled/TicketDiscount.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TicketDiscountIcon({ className, dataTestid = "TicketDiscountIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TicketDiscount data-testid={dataTestid} className={classes} {...rest} />
  );
}
